/** KA fixed tote QR — paste once on tray; assign orders in app (no reprint). */

export const TOTE_STAGE_LABELS = {
  empty: "Empty tote",
  baked: "Base in tote",
  frosted: "Frosted cake",
  decorated: "Decorated cake",
  packed: "Packed — clear tote",
};

/** @deprecated use TOTE_STAGE_LABELS */
export const UNIT_STAGE_LABELS = TOTE_STAGE_LABELS;

export function parseToteCodeFromText(raw) {
  const text = (raw || "").trim();
  if (!text) return "";
  const upper = text.toUpperCase();
  for (const marker of ["/KA/T/", "/KA/U/"]) {
    const idx = upper.indexOf(marker);
    if (idx >= 0) {
      return upper
        .slice(idx + marker.length)
        .split("?")[0]
        .split("#")[0]
        .replace(/\//g, "")
        .slice(0, 10);
    }
  }
  try {
    const u = new URL(text, window.location.origin);
    const q = u.searchParams.get("code");
    if (q) return q.trim().toUpperCase().slice(0, 10);
  } catch {
    /* plain code */
  }
  return upper.replace(/\s/g, "").slice(0, 10);
}

/** @deprecated */
export const parseUnitCodeFromText = parseToteCodeFromText;

export function toteStageTone(stage) {
  const s = (stage || "empty").toLowerCase();
  if (s === "empty") return "muted";
  if (s === "packed" || s === "decorated") return "good";
  if (s === "frosted") return "warn";
  return "info";
}

/** @deprecated */
export const unitStageTone = toteStageTone;

export async function fetchToteForOrder({ token, orderId, role, cakeIndex = 0 }) {
  const params = new URLSearchParams({
    token,
    order_id: orderId,
    cake_index: String(cakeIndex),
    role: role || "baker",
  });
  const res = await fetch(`/api/production/tote/for-order?${params.toString()}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not load tote");
  return data;
}

/** @deprecated */
export const fetchUnitForOrder = fetchToteForOrder;

export async function assignToteToOrder({ token, orderId, role, cakeIndex = 0, toteCode }) {
  const res = await fetch("/api/production/tote/assign", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token,
      order_id: orderId,
      role,
      cake_index: cakeIndex,
      tote_code: parseToteCodeFromText(toteCode),
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not assign tote");
  return data;
}

export async function scanProductionTote({ token, code, role, worker = "" }) {
  const res = await fetch("/api/production/tote/scan", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token,
      code: parseToteCodeFromText(code),
      role,
      worker: worker || undefined,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Scan failed");
  return data;
}

/** @deprecated */
export const scanProductionUnit = scanProductionTote;

export async function clearProductionTote({ token, code, role = "baker" }) {
  const res = await fetch("/api/production/tote/clear", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token,
      code: parseToteCodeFromText(code),
      role,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not clear tote");
  return data;
}

/** @deprecated — packed totes should be cleared */
export const packProductionUnit = clearProductionTote;

export async function listProductionTotes({ token }) {
  const params = new URLSearchParams({ token });
  const res = await fetch(`/api/production/tote/list?${params.toString()}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not list totes");
  return data;
}
